import { useNavigate, useParams } from 'react-router-dom';
import { ArrowBack } from '@mui/icons-material';
import { Box, Button } from '@mui/material';

import { ResourceDetailShell } from '../../components/resource-views/resource-detail-shell';
import { resourceLabel } from '../../components/resource-views/registry';
import {
  parseResourceScope,
  resourceListPath,
} from '../../utils/resource-routes';

/**
 * One resource's detail view (GDN-2723).
 *
 * "Up" is the type's list within the same scope — derived from the route, not
 * from history, so it behaves the same however you arrived.
 */
export default function ResourceDetailPage() {
  const params = useParams<{
    organizationId?: string;
    userId?: string;
    resourceType?: string;
    resourceId?: string;
  }>();
  const navigate = useNavigate();
  const scope = parseResourceScope(params);
  const { resourceType, resourceId } = params;

  if (!scope || !resourceType || !resourceId) return null;

  return (
    <Box>
      <Button
        onClick={() => navigate(resourceListPath(scope, resourceType))}
        startIcon={<ArrowBack />}
        sx={{ mb: 2 }}
      >
        Back to {resourceLabel(resourceType)} list
      </Button>
      <ResourceDetailShell
        resourceType={resourceType}
        resourceId={resourceId}
        scope={scope}
      />
    </Box>
  );
}
